export default class MvApng {
    constructor() {
        this.skipIntroDelayOffset = document.body.classList.contains("-skipIntro") ? 600 : 0;

        // -load から APNG を発火するまでの秒数(ms)をセレクタごとに指定する
        this.groups = [
            // js-mv-ttl の場合: タイトル・クレジット(picture/source + img)
            { els: document.querySelectorAll(".js-mv-ttl"), delay: 1700 },
            // js-mv-year の場合: 年表記(img のみ)
            { els: document.querySelectorAll(".js-mv-year"), delay: 2300 },
        ].filter((group) => group.els.length);

        if (!this.groups.length) return;

        if (document.body.classList.contains("-load")) {
            this.setSchedule();
        } else {
            window.addEventListener("load", () => this.setSchedule(), { once: true });
        }
    }

    setSchedule() {
        this.groups.forEach((group) => {
            setTimeout(() => this.playApng(group.els), this.getDelay(group.delay));
        });
    }

    getDelay(delay) {
        return Math.max(0, delay - this.skipIntroDelayOffset);
    }

    playApng(els) {
        els.forEach((el) => {
            // data 属性に退避していた URL があれば入れて、その瞬間に APNG を頭から再生させる
            el.querySelectorAll("source[data-srcset]").forEach((source) => {
                source.srcset = source.dataset.srcset;
                source.removeAttribute("data-srcset");
            });
            el.querySelectorAll("img[data-src]").forEach((img) => {
                img.src = img.dataset.src;
                img.removeAttribute("data-src");
            });
            el.classList.add("-active");
        });
    }
}
